import { SimpleSelect, SimpleSelectOption } from '@workwave-tidal/core/components'

import { useTexts } from '../useTexts'

type EligibilityType = uui.domain.client.rm.Eligibility['type']

type Props = {
  type: EligibilityType
  onChangeType: (type: EligibilityType) => void
  label: string
}

export function EligibilityTypePicker(props: Props) {
  const { type, onChangeType, label } = props

  const texts = useTexts()

  const options: SimpleSelectOption<string>[] = [
    { label: texts.anyTranslation, value: 'any' },
    { label: texts.onDayTranslation, value: 'on' },
    { label: texts.byDayTranslation, value: 'by' },
  ]

  return (
    <SimpleSelect
      label={label}
      value={type}
      onChange={event => onChangeType(event.target.value as EligibilityType)}
      options={options}
    />
  )
}
